import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { postNewsLetter } from "../../../services/CommonService";
import Utils from "../../../utils";
import { CURRENT_YEAR } from "../../../configs/AppConfig";
import { useTranslation } from "react-i18next";

import "./GuestFooter.css";

function GuestFooter() {
  const { t } = useTranslation("translation");

  const [email, setEmail] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({ email: "" });
  const canvasRef = useRef(null);

  useEffect(() => {
    const toggleVisible = () => {
      const scrolled = document.documentElement.scrollTop;
    };
    window.addEventListener("scroll", toggleVisible);
    return () => window.removeEventListener("scroll", toggleVisible);
  }, []);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const onSubmitNewsLetter = (e) => {
    e.preventDefault();
    setErrors({ email: "" });

    if (!email) {
      setErrors({ email: t("footer.errorEmptyEmail") });
      return;
    }
    if (!validateEmail(email)) {
      setErrors({ email: t("footer.errorInvalidEmail") });
      return;
    }

    setIsDisabled(true);
    postNewsLetter({ email })
      .then((response) => {
        setIsDisabled(false);
        setEmail("");
        toast.success(response.data.message);
      })
      .catch((err) => {
        setIsDisabled(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  return (
    <footer className="guest-footer">
      <div className="guest-footer-container">
        <div className="guest-footer-row">
          
          {/* Column 1 */}
          <div className="guest-footer-column">
            <h2>{t("footer.title")}</h2>
            <p>{t("footer.description")}</p>
          </div>

          {/* Column 2 */}
          <div className="guest-footer-column">
            <address>
              <strong>{t("footer.companyName")}</strong>
              <br />
              {t("footer.addressLine1")} <br />
              {t("footer.addressLine2")}
            </address>
          </div>

          {/* Column 3 - Newsletter */}
          <div className="guest-footer-column">
            <h5>{t("footer.newsletterTitle")}</h5>
            <p>{t("footer.newsletterSubtitle")}</p>

            <form onSubmit={onSubmitNewsLetter} noValidate>
              <div className="guest-footer-form-group">
                <input
                  type="email"
                  className={`guest-footer-input ${errors.email ? "error" : ""}`}
                  placeholder={t("footer.emailPlaceholder")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isDisabled}
                  aria-label={t("footer.emailPlaceholder")}
                  required
                />

                <button
                  type="submit"
                  className="guest-footer-button"
                  disabled={isDisabled}
                  aria-disabled={isDisabled}
                  aria-label={t("footer.subscribe")}
                >
                  {isDisabled ? (
                    <span className="spinner"></span>
                  ) : (
                    t("footer.subscribe")
                  )}
                </button>
              </div>

              {errors.email && (
                <div className="guest-footer-error">{errors.email}</div>
              )}
            </form>
          </div>
        </div>

        {/* bottom section */}
        <div className="guest-footer-bottom">
          <div>
            &copy; {CURRENT_YEAR} <span>DocuSafe.ai</span>. {t("footer.rights")}
          </div>

          <div className="guest-footer-madeby">
            {t("footer.madeWith")}{" "}
            <span role="img" aria-label="bulb">💡</span> {t("footer.byAlumni")}{" "}
            <a href="https://www.iima.ac.in/" target="_blank" rel="noopener noreferrer">
              IIM Ahmedabad
            </a>{" "}
            {t("footer.and")}{" "}
            <a href="https://www.bits-pilani.ac.in/" target="_blank" rel="noopener noreferrer">
              BITS Pilani
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default GuestFooter;
